export default __webpack_public_path__ + "static/media/pbix.3fbcb147.svg";